import Vuex from "vuex";
import Vue from "vue";
import axios from "axios";
import router from "../router";
import { filtersMapper, applyFilter } from '@/helpers/modelMapper'
import { FILTER_TYPE } from "@/constantData";
import { flags } from "./static/labelsList.json";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    newResult: [],
    staticFilters: [],
    generatedFilterList: [],
    filteredResult: [],
    filters: [],
    results: [],
    params: [],
    urlPrefix: window.tourFilterData.requestFilterUrl,
    tourCategoryId: window.tourFilterData.tourCategoryId,
    tourCategoryTitle: "",
    imagePrefixAddress: window.tourFilterData.imagePrefixAddress,
    filterUrlPrefix: window.tourFilterData.requestFilterItemUrl,
    isUserAuthenticated:
      window.tourFilterData.isUserAuthenticated === "True" ? true : false,
    sortPrefix: "sort",
    sortType: "minPrice",
    totalResultCount: 0,
    showLoadMore: false,
    openFilterMobile: false,
    loading: true,
    pageNumber: 1,
  },

  getters: {
    getNewResults: (state) => {
      return state.newResult;
    },

    getTourCategoryId: (state) => {
      return state.tourCategoryId;
    },

    getFilteredResults: (state) => {
      return state.filteredResult;
    },

    getStaticFilters(state) {
      return state.generatedFilterList;
    },

    getTourCategoryTitle(state) {
      return state.tourCategoryTitle;
    },

    getImagePrefixAddress: (state) => {
      return state.imagePrefixAddress;
    },

    getIsUserAuthenticated: (state) => {
      return state.isUserAuthenticated;
    },

    getLoading: (state) => {
      return state.loading;
    },

    getDataParams: (state) => {
      if (state.params.length > 0) {
        return "/" + state.params.join("/");
      }
      return "";
    },

    getPageParams: (state) => {
      if (state.pageNumber > 1) {
        return "/page/" + state.pageNumber;
      }
      return "";
    },

    getUrlPrefix: (state) => {
      return state.urlPrefix;
    },

    getFilterUrlPrefix: (state) => {
      return state.filterUrlPrefix;
    },

    createFilterRequestData: (state, getters) => {
      return (
        "/" + state.sortPrefix + "/" + state.sortType + getters.getDataParams
      );
    },

    createLoadMoreRequestData: (state, getters) => {
      return (
        "/" + state.sortPrefix + "/" + state.sortType + getters.getPageParams
      );
    },

    getPageNumber: (state) => {
      return state.pageNumber;
    },

    getOpenFilterMobile: (state) => {
      return state.openFilterMobile;
    },

    getSortType: (state) => {
      return state.sortType;
    },

    getTotalCount: (state) => {
      return state.totalResultCount
    }
  },

  actions: {
    postRequest(context, payload) {

      axios({
        method: "post",
        url: payload.url,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
        data: payload.data,
      }).then((response) => {
        if (response.data.isSucceed) {
          payload.payload(response);
        }
      });
    },

    getRequest(context, payload) {
      axios({
        method: "get",
        url: `${payload.url}/`,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
        data: payload.data,
      }).then((response) => {
        if (response) {
          payload.payload(response);
        }
      });
    },

    updatePageNumber(context, pageNumber) {
      context.commit("UPDATE_PAGE_NUMBER", Number(pageNumber));
    },

    filterGenerator(context, results) {
      const staticFilters = filtersMapper(results)

      context.commit("updateStaticFilters", staticFilters);
      context.commit("updateGeneratedFilterList", staticFilters);
    },

    filterFetchedData(context) {
      const { newResult, filteredResult, staticFilters } = context.state;
      context.commit("updateFilteredResult", newResult);

      context.commit("fillTotalCount", context.state.filteredResult.length);

      const activeFilters = staticFilters.filter(filter => (filter.selectedValues.length > 0 || filter.selectedValues.minVal))

      const filteredPackages = applyFilter(
        activeFilters,
        newResult
      );

      context.commit("updateFilteredResult", filteredPackages);

      context.dispatch("changeLoading", false);
    },

    fetchFilterData(context, url) {
      context.dispatch("changeLoading", true);

      const convertBinaryToArray = (number = 0) => {
        return number
          .toString(2)
          .split('')
          .reverse()
          .reduce((acc, bit, index) => {
            if (bit === "1") {
              const match = flags.find(flag => flag.id === Math.pow(2, index));
              if (match) acc.push(match);
            }
            return acc;
          }, []);
      };

      const requestListData = {
        url: url,
        payload: (response) => {
          const updatedResult = response.data.model.map(element => ({
            ...element,
            labels: convertBinaryToArray(element.labels),
          }));

          context.commit("updateResult", updatedResult);
          context.dispatch("filterFetchedData", updatedResult);
          context.dispatch("filterGenerator", context.state.newResult);
          context.dispatch("updatePageNumber", 1);
          context.dispatch("changeLoading", false);
          context.dispatch("showLoadMore");
        },
      };

      context.dispatch("getRequest", requestListData);
    },

    createRangeFilterItem(context, items) {
      return new Promise((resolve) => {
        let rangeFilterItems = [];
        rangeFilterItems.push(...items);
        let rangeFilterValue = rangeFilterItems.join("_");
        resolve(rangeFilterValue);
      });
    },

    // change filter function
    onChangeFilter(context, payload) {
      const { filter, filterItem } = payload
      context.dispatch("changeLoading", true);

      if (
        filter.type === FILTER_TYPE.LIST
      ) {
        if (filter.selectedValues.includes(filterItem.value)) {
          filter.selectedValues = filter.selectedValues.filter(filter => filter !== filterItem.value)

          context.commit("updateFilters", {
            filterId: filter.id,
            selectedValues: filter.selectedValues,
          });

          context.dispatch("filterFetchedData", context.getters.getUrlPrefix);
        } else {
          payload.filter.selectedValues.push(payload.filterItem.value)

          context.commit("updateFilters", {
            filterId: filter.id,
            selectedValues: filter.selectedValues,
          });

          context.dispatch("filterFetchedData", context.getters.getUrlPrefix);
        }
      } else if (filter.type === FILTER_TYPE.RANGE) {
        context.commit("updateFilters", {
          filterId: filter.id,
          selectedValues: filter.selectedValues,
        });

        context.dispatch("filterFetchedData", context.getters.getUrlPrefix);
      }
    },

    updateSort(context, payload) {
      context.dispatch("changeLoading", true);

      if (payload !== "0") {
        context.commit("updateSortType", payload);
      } else {
        context.commit("updateSortType", "");
      }
      context.dispatch("fetchFilterData", context.getters.getUrlPrefix);
    },

    loadMoreResult(context) {
      var data = new FormData();
      data.set("params", context.getters.createLoadMoreRequestData);

      const loadResultData = {
        url: context.getters.getUrlPrefix,
        data,

        payload: (response) => {
          context.commit("addLoadMoreItems", response.data.model.tours);
          context.dispatch("scrollToTop");
        },
      };
      context.dispatch("postRequest", loadResultData);
      context.dispatch("showLoadMore");
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    showLoadMore({ commit, state }) {
      commit(
        "updateShowMore",
        state.results.length < state.totalResultCount ? true : false
      );
    },

    toggleFilterBoxMobile({ commit }) {
      commit("updateOpenFilterMobile");
    },

    clearFilters(context) {
      context.commit("addParamsList", []);
      context.commit("updateFilterItems", []);
      context.dispatch(
        "fetchFilterData",
        context.getters.getUrlPrefix + context.getters.getDataParams
      );
    },

    changeLoading({ commit }, value) {
      commit("updateLoading", value);
    },

    showAlert(context, messages, position = "#js-fixed-alert-wrapper") {
      for (var k in messages.messages) {
        var tmpMessage = [k, messages.messages[k]];
        var boxClass = "",
          iconClass = "";

        if (tmpMessage && tmpMessage[1] && tmpMessage[1].message) {
          var message = tmpMessage[1].message;
          var status = parseInt(tmpMessage[1].type);

          if (!message) {
            message = tmpMessage[0];
            status = parseInt(tmpMessage[1]);
          }
          switch (status) {
            case 1: {
              //Success
              boxClass = "alert--success";
              iconClass = "icon-check";
              break;
            }
            case 8: {
              //Error
              boxClass = "alert--danger";
              iconClass = "icon-close";
              break;
            }
            case 4: {
              //Warning
              boxClass = "alert--warning";
              iconClass = "icon-warning-line";
              break;
            }
            case 2: {
              //Info
              boxClass = "alert--info";
              iconClass = "icon-information-line";
              break;
            }
          }

          var para = document.createElement("div");
          var paraText = document.createElement("span");
          var paraIcon = document.createElement("i");

          var node = document.createTextNode(message);
          paraText.appendChild(node);

          paraIcon.classList.add(iconClass);

          para.appendChild(paraIcon);
          para.appendChild(paraText);

          para.classList.add("alert", boxClass);

          var alertId = "js-message-" + Date.now();

          para.setAttribute("id", alertId);

          var element = document.querySelector(position);

          if (element) {
            element.appendChild(para);
          } else {
            document.querySelector("body").appendChild(para);
          }

          setTimeout(function () {
            document.getElementById(alertId).style.height = 0;
            document.getElementById(alertId).remove();
          }, 7000);
        }
      }
    },
  },

  mutations: {
    updateGeneratedFilterList(state, value) {
      state.generatedFilterList = value;
    },

    updateStaticFilters(state, value) {
      state.staticFilters = value
    },

    updateFilters(state, payload) {
      const { filterId, selectedValues } = payload
      state.staticFilters.find(filter => filter.id === filterId).selectedValues = selectedValues
    },

    updateLoading(state, value) {
      state.loading = value;
    },
    UPDATE_PAGE_NUMBER(state, value) {
      state.pageNumber = value ? value : state.pageNumber++;
    },
    addParamsList(state, defaultParams) {
      state.params = [...defaultParams];
    },
    updateFilterItems(state, filters) {
      state.filters = filters;
    },

    updateResult(state, results) {
      state.newResult = [...results];
    },

    updateFilteredResult(state, results) {
      state.filteredResult = [...results];
    },

    addItemToParams(state, payload) {
      if (payload.type === "range") {
        let itemIsAdded = false;
        let firstItemValue = payload.value.split("_")[0];
        state.params.map((param, index) => {
          if (param.includes(firstItemValue)) {
            state.params.splice(index, 1);
            state.params.push(payload.value);
            itemIsAdded = true;
            return;
          }
        });
        if (!itemIsAdded) {
          state.params.push(payload.value);
        }
      } else if (
        payload.type === "list" &&
        !state.params.includes(payload.value)
      ) {
        state.params.push(payload.value);
      }
    },

    removeItemFromParams(state, payload) {
      for (let i = 0; i < state.params.length; i++) {
        if (state.params[i] === payload) {
          state.params.splice(i, 1);
        }
      }
    },

    updateSortType(state, payload) {
      state.sortType = payload;
    },

    fillTotalCount(state, payload) {
      state.totalResultCount = payload;
    },

    updatePageNumber(state) {
      state.pageNumber++;
    },

    addLoadMoreItems(state, payload) {
      state.results = [...payload];
    },

    updateShowMore(state, payload) {
      state.showLoadMore = payload;
    },

    updateOpenFilterMobile(state) {
      state.openFilterMobile = !state.openFilterMobile;
      if (state.openFilterMobile) {
        document.querySelector("body").classList.add("no-scroll");
      } else {
        document.querySelector("body").classList.remove("no-scroll");
      }
    },
  },
});
